export enum DrainageAmountEnum {
  None = 1,
  Small = 2,
  Moderate = 3,
  Large = 4
}

export const DrainageAmountOptions = [
{ id: 1, label: 'None' },
{ id: 2, label: 'Small' },
{ id: 3, label: 'Moderate' },
{ id: 4, label: 'Large' }
];
